import { render, staticRenderFns } from "./NewFileRequestDialog.vue?vue&type=template&id=747d2488"
import script from "./NewFileRequestDialog.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialog.vue?vue&type=style&index=0&id=747d2488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports